import React, { PropTypes, Component } from 'react'
import styles from './styles'
import misc from 'utils/misc'
import NewDataInput from './newDataInput'
import co from 'co'

export default class NewDataForm extends Component {
  static propTypes = {
    schemas: PropTypes.array.isRequired,
    dataUtil: PropTypes.object.isRequired,
    loadDataArrayFromServer: PropTypes.func.isRequired,
  };

  constructor (props, context) {
    super(props, context)
    this.clearState = ::this.clearState
    this.onDataUpdate = ::this.onDataUpdate
    this.handleSubmit = ::this.handleSubmit
  }

  componentWillMount () {
    this.clearState()
  }

  shouldComponentUpdate (nextProps, nextState) {
    return (!misc.isObjectEqual(this.props, nextProps) ||
            !misc.isObjectEqual(this.state, nextState))
  }

  onDataUpdate (key, value) {
    const state = {}
    state[key.toString()] = value
    this.setState(state)
  }

  clearState () {
    const state = {}
    this.props.schemas.forEach(schema => {
      state[schema.key] = ''
    })
    this.setState(state)
  }

  handleSubmit () {
    // dataUtil.create();
    const newData = this.state
    const dataUtil = this.props.dataUtil
    co(function*() {
      yield dataUtil.create(newData)
    })
    .then(() => {
      this.props.loadDataArrayFromServer()
    })
    .catch(e => {
      console.log(`in error: onUpdateServerState ${e.stack}`)
    })

    this.clearState()
  }

  render () {
    return (
      <div className={styles.newDataForm}>
        {this.props.schemas.map(schema =>
          <NewDataInput
            key={schema.key}
            value={this.state[schema.key]}
            schema={schema}
            onDataUpdate={this.onDataUpdate}
          />)
        }
        <div className={styles.submit}>
          <input type="submit" value="新增" onClick={this.handleSubmit} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataSyncTable/newDataForm.jsx